import { RootState } from 'redux/reducers/rootReducer';

const industriesSelector = (state: RootState) => state.qualification.industries;
const isIndustriesLoadingSelector = (state: RootState) =>
  state.qualification.isIndustriesLoading;

export { industriesSelector, isIndustriesLoadingSelector };
